import { render, staticRenderFns } from "./apiKeysPage.vue?vue&type=template&id=50b2a973"
import script from "./apiKeysPage.vue?vue&type=script&lang=ts"
export * from "./apiKeysPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports